import React from 'react'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import { withTranslation } from "react-i18next";

import { LangSelectView } from '../lang-select/LangSelect'
import { copyPortalFromLang } from '../../../actions/portal'

class GeneralInfoFieldCopy extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      language: 'th',
    }
  }

  handleChange = ({ target: { value: language } }) => {
    this.setState({ language })
  }

  handleCopyClick = () => {
    if (
      window.confirm(
        `จะคัดลอกข้อมูลจากภาษา ${this.state.language} มาที่ภาษา ${
          this.props.language
        } ?`,
      )
    ) {
      this.props.actions.copyContentFromLang(
        this.state.language,
        this.props.language,
      )
    }
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <span style={{ paddingRight: 4 }}> คัดลอกข้อมูลจาก </span>
        <LangSelectView onChange={this.handleChange} value={this.state.value} />
        <button
          style={{ marginLeft: 4 }}
          className="button is-primary"
          onClick={this.handleCopyClick}
        >
          {this.props.i18n.t('actions.copy.label')}
        </button>
      </div>
    )
  }
}

export default compose(
  withTranslation(),
  connect(
    ({ info: { language } }) => ({ language }),
    dispatch => ({
      actions: bindActionCreators(
        { copyContentFromLang: copyPortalFromLang },
        dispatch,
      ),
    }),
  ),
)(GeneralInfoFieldCopy)



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoFieldCopy.js